// extracted by mini-css-extract-plugin
export default {"favoriteButtonIcon":"FavoriteButton_favoriteButtonIcon__muHMt"};